/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Form_Err_GenericInputs */

const en_cp_form_err_generic = /** @type {(inputs: Cp_Form_Err_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to send. Try again.`)
};

const id_cp_form_err_generic = /** @type {(inputs: Cp_Form_Err_GenericInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gagal mengirim. Coba lagi.`)
};

/**
* | output |
* | --- |
* | "Failed to send. Try again." |
*
* @param {Cp_Form_Err_GenericInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_form_err_generic = /** @type {((inputs?: Cp_Form_Err_GenericInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Form_Err_GenericInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_form_err_generic(inputs)
	return en_cp_form_err_generic(inputs)
});